import React, { ReactNode } from 'react';
import { ContextTransferenciaInteligente } from '../interfaces/sweeping';

interface Props {
    children: ReactNode
}

let dadosTransferenciaInteligente: ContextTransferenciaInteligente = {
    hasData: false,
    dados: {
        instituicao: {
            nome: "",
            cnpj: "",
            icone: "",
            id: ""
        },
        id: "",
        dataInicio: "",
        horaLimite: "",
        nome: "",
        cpf: "",
        recurringConsentId: "",
        contaPagadora: {
            nome: "",
            contaCorrente: "",
            agencia: "",
            formaPagamento: "",
            tipoConta: ""
        },
        contaRecebedora: {
            nome: "",
            contaCorrente: "",
            agencia: ""
        },
        dadosVinculo: {
            descricao: "",
            gatilhos: [],
            dataEncerramento: "", 
            idVinculo: "",
            limiteVinculo: "",    
            limiteTransacao: ""
        },
        creationDateTime: "",
        creditorCpfCnpj: "",
        loggedUserDocIdentification: "",
        jornadaOtimizada: {
            valor: false 
        }
    },
    payload: {
        autenticacaoEletronica: "",
        biometriaFacial: "",
        hashDispositivo: "",
        hashTransacao: "",
        teclas: [],
        tokenSMS: "",
        unitoken: ""
    },
    iniciadora: {
        urlRedirecionamento: "",
        urlLogoIniciadora: "",
        pendente: false
    }
};

export const TransferenciaInteligenteRequest = React.createContext(dadosTransferenciaInteligente);

export const TransferenciaInteligenteProvider = ({ children }: Props) => {

    return (
        <TransferenciaInteligenteRequest.Provider value={dadosTransferenciaInteligente}>
            {children}
        </TransferenciaInteligenteRequest.Provider>
    );
}